import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import Layout from '@/components/Layout'
import Admin from '@/pages/Admin'
import AdminMessages from '@/pages/AdminMessages'
import AdminProgress from '@/pages/AdminProgress'
import AuthPage from '@/pages/AuthPage'
import Classroom from '@/pages/Classroom'
import Contact from '@/pages/Contact'
import CourseDetail from '@/pages/CourseDetail'
import CourseHome from '@/pages/CourseHome'
import Courses from '@/pages/Courses'
import Dashboard from '@/pages/Dashboard'
import Home from '@/pages/Home'
import Instructors from '@/pages/Instructors'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'cursos', element: <Courses /> },
      { path: 'cursos/:slug', element: <CourseDetail /> },
      { path: 'instructores', element: <Instructors /> },
      { path: 'contacto', element: <Contact /> },
      { path: 'acceso', element: <AuthPage /> },
      { path: 'panel', element: <Dashboard /> },
      { path: 'panel/:slug', element: <CourseHome /> },
      { path: 'admin', element: <Admin /> },
      { path: 'admin/avance', element: <AdminProgress /> },
      { path: 'admin/mensajes', element: <AdminMessages /> },
      { path: 'aula/:slug', element: <Classroom /> },
    ],
  },
]

function App() {
  return useRoutes(routes)
}

export default App
